import axios from "axios";
export const adminIndicatorsApi = () => {
  return axios.get(`/admin/home/indicators`);
};
export const partnerAchievementsApi = () => {
  return axios.get(`/client/home/my-achievements`);
};
export const totalAdminRequestsApi = () => {
  return axios.get(`/admin/home/get-total-requests-number`);
};
export const pendingRequestsApi = () => {
  return axios.get(`/admin/payment/requests/sidebar/pending`);
};
export function partnerEMoneyRequestsApi(searchTerm = "", page = 1) {
  return axios.get(`/client/request/list`, {
    params: { search: searchTerm, page },
  });
}
export const partnerProfileApi = (id) => {
  return axios.get(`/admin/partners-list/profile/${id}`);
};
export const viewPaymentDetailsApi = (id) => {
  return axios.get(`/admin/payment/requests/details/${id}`);
};
export const viewAdminCoursesApi = (page) => {
  return axios.get(`/admin/reports/courses/view`, {
    params: {
      page,
    },
  });
};

// Taswia
export const taswiaListApi = (
  searchTerm = "",
  startDate = "",
  endDate = "",
  page = 1
) => {
  return axios.get("/admin/taswia/list", {
    params: {
      SelectionDateStart: startDate,
      SelectionDateEnd: endDate,
      search: searchTerm,
      page: page,
    },
  });
};

export const canCreateTaswiaApi = () => {
  return axios.get("/admin/taswia/can-create");
};

export const lastTaswiaEndDateApi = () => {
  return axios.get("/admin/taswia/last-taswia-end-date");
};

export const createTaswiaApi = (endDate, confirm) => {
  return axios.post("/admin/taswia/create", null, {
    params: {
      end_date: endDate,
      confirm: confirm,
    },
  });
};

export const listUnsettledClientsApi = (taswiaId, page = 1) => {
  return axios.get(`/admin/taswia/unsettled-clients/${taswiaId}`, {
    params: { page },
  });
};
export const listSettledClientsApi = (taswiaId, page = 1) => {
  return axios.get(`/admin/taswia/settled-clients/${taswiaId}`, {
    params: { page },
  });
};

export const viewClientToSettleApi = (taswiaId, partnerId) => {
  return axios.get(
    `/admin/taswia/view-client-to-settle/${taswiaId}/${partnerId}`
  );
};

export const viewClientCurrentCollectionApi = (
  taswiaId,
  partnerId,
  page = 1,
  pageParam = "page"
) => {
  return axios.get(
    `/admin/taswia/client-current-collection/${taswiaId}/${partnerId}`,
    {
      params: { [pageParam]: page },
    }
  );
};

export const confirmTaswiaApi = (taswiaId, partnerId) => {
  return axios.get(`/admin/taswia/confirm/${taswiaId}/${partnerId}`);
};

export const viewSettlementSummaryApi = (taswiaId) => {
  return axios.get(`/admin/taswia/settlement-summery/${taswiaId}`);
};

export const endTaswiaApi = (id, notes, confirm) => {
  return axios.post(`/admin/taswia/end/${id}`, {
    notes: notes,
    confirm: confirm,
  });
};

export const viewPartnerSettlementDetailsApi = (
  taswiaId,
  partnerId,
  page = 1,
  pageParam = "page"
) => {
  return axios.get(
    `/admin/taswia/partner-settlement-details/${taswiaId}/${partnerId}`,
    {
      params: { [pageParam]: page },
    }
  );
};

export const viewSettlementHistoryApi = (taswiaId, page = 1) => {
  return axios.get(`/admin/taswia/finished-taswia-history/${taswiaId}`, {
    params: { page },
  });
};

// Replace eMoney

export const earningWalletApi = (id) => {
  return axios.get(`/admin/replace/emoney/earning-wallet/${id}`);
};

export function pendingEMoneyRequestsApi(searchTerm = "", page = 1) {
  return axios.get(`/admin/replace/emoney/pending`, {
    params: { search: searchTerm, page },
  });
}
export function totalPendingEMoneyRequestsNumber() {
  return axios.get(`/admin/replace/emoney/totalPendingNumber`);
}
export function totalUnseenMessages() {
  return axios.get(`/admin/message/unseen-count`);
}

export function acceptedEMoneyRequestsApi(searchTerm = "", page = 1) {
  return axios.get(`/admin/replace/emoney/accepted`, {
    params: { search: searchTerm, page },
  });
}

export function rejectedEMoneyRequestsApi(searchTerm = "", page = 1) {
  return axios.get(`/admin/replace/emoney/rejected`, {
    params: { search: searchTerm, page },
  });
}

export const viewEMoneyDetailsApi = (id) => {
  return axios.get(`/admin/replace/emoney/details/${id}`);
};

export const acceptEMoneyRequestApi = (id) => {
  return axios.post(`/admin/replace/emoney/accept/${id}`);
};

export const rejectEMoneyRequestApi = (id) => {
  return axios.post(`/admin/replace/emoney/reject/${id}`);
};

// partner replace emoney

export const replaceEmoneyRequestApi = (formData) => {
  return axios.post(`/client/replace/emoney`, formData);
};

export const viewEarningWalletApi = () => {
  return axios.get(`/client/replace/emoney/earning-wallet`);
};

export function viewAllReplacementReqsApi(searchTerm = "", page = 1) {
  return axios.get(`/client/replace/emoney/list`, {
    params: { search: searchTerm, page },
  });
}

export const viewEmoneyTransferTypesApi = () => {
  return axios.get(`/client/emoney-transfer/types`);
};

export const searchTransferTo = async (userSearch) => {
  try {
    const response = await axios.get(
      `/client/emoney-transfer/search/${userSearch}`
    );
    return response.data.data;
  } catch (error) {
    console.error("Error searching for user:", error);
    return [];
  }
};

export const checkWalletBalance = async (transferValue) => {
  try {
    const response = await axios.get(
      `/client/emoney-transfer/check-wallet/${transferValue}`
    );
    return response.data.data;
  } catch (error) {
    console.error("Error checking wallet balance:", error);
    return false;
  }
};
// from wallet to another wallt
export const submitTransfer = async (values) => {
  try {
    const response = await axios.post(
      "/client/emoney-transfer/different-wallets",
      {
        transfer_to: values.transfer_to,
        transfer_value: values.transfer_value,
        notes: values.notes,
        confirm: values.confirm ? 1 : 0,
        transfer_type: values.transfer_type,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error submitting transfer:", error);
    throw error;
  }
};

// send otp to transfer from person wallet to another person wallet
export const submitTransferToAnotherOtp = async (otp) => {
  try {
    const response = await axios.post("/client/emoney-transfer/verifyOtp", {
      otp,
    });
    return response.data;
  } catch (error) {
    console.error("Error submitting transfer:", error);
    throw error;
  }
};
// send otp to replace e-money
export const submitReplaceEMoneyOtp = async (otp) => {
  try {
    const response = await axios.post("/client/replace/emoney/verifyOtp", {
      otp,
    });
    return response.data;
  } catch (error) {
    console.error("Error submitting Replace EMoney :", error);
    throw error;
  }
};
// resend otp to transfer from person wallet to another person wallet
export const ResendOtpForSubmitTransfer = async () => {
  try {
    const response = await axios.get("/client/emoney-transfer/resendOtp");
    return response.data;
  } catch (error) {
    console.error("Error resendOtp for transfer:", error);
  }
};
// resend otp For Replace EMoney
export const ResendOtpForReplaceEMoney = async () => {
  try {
    const response = await axios.get("/client/replace/emoney/resendOtp");
    return response.data;
  } catch (error) {
    console.error("Error resendOtp for Replace E-Money:", error);
  }
};

// Announcements APIS

export function announcementsListApi(page = 1, sortBy, sortDir) {
  return axios.get(`/admin/announcement/list`, {
    params: {
      page,
      sort_by: sortBy,
      sort_dir: sortDir,
    },
  });
}

export const createAnnouncement = async (announcementData) => {
  try {
    const formData = new FormData();

    // Add text fields to FormData
    formData.append("announcement_title", announcementData.announcement_title);
    formData.append(
      "announcement_details",
      announcementData.announcement_details
    );
    formData.append("link_url", announcementData.link_url || "");
    formData.append("on_portal", announcementData.on_portal ? 1 : 0);
    formData.append("schedule_date", announcementData.schedule_date);
    formData.append("announce_for", announcementData.announce_for);
    formData.append("link_text", announcementData.link_text || "");

    // Add file to FormData
    if (announcementData.image) {
      formData.append("image", announcementData.image);
    }

    const response = await axios.post("/admin/announcement/store", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response;
  } catch (error) {
    console.error("Error storing announcement:", error);
    throw error;
  }
};

export const updateAnnouncement = async (id, formData) => {
  try {
    const response = await axios.post(
      `/admin/announcement/update/${id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    console.log("Announcement updated successfully:", response.data);
    return response;
  } catch (error) {
    console.error("Error updating announcement:", error);
    throw error;
  }
};

export const announceForListApi = () => {
  return axios.get(`/admin/announcement/announce-for-dropdown`);
};

export const AnnouncementLinkKeywordApi = () => {
  return axios.get(`/admin/announcement/link-keyword-dropdown`);
};

export const announcementDetailstApi = (id) => {
  return axios.get(`/admin/announcement/details/${id}`);
};

export const manageWallet = async (walletData) => {
  try {
    const response = await axios.post(
      "/admin/wallet/management",
      {
        client_id: walletData.client_id,
        wallet_type: walletData.wallet_type,
        action_type: walletData.action_type,
        amount: walletData.amount,
        reason: walletData.reason,
        confirm: walletData.confirm === true ? 1 : 0,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error managing wallet:", error);
    throw error;
  }
};

export const searchClientInWalletApi = (searchTerm) => {
  return axios.get(`/admin/wallet/management/search/${searchTerm}`);
};

// Accounts Review Details
export const accountsReviewProfileDetailsApi = (id) => {
  return axios.get(`/admin/reviewClientAccount/viewAccountDetails/${id}`);
};
export const getClientsCategoriesApi = () => {
  return axios.get(`/new/client/getClientCategories`);
};
export const getListReviewsNumber = () => {
  return axios.get(`/admin/reviewClientAccount/reviewsNumber`);
};
export const getPartnerProfileDataToUpdate = (partnerId) => {
  return axios.get(`/admin/partners-list/clientData/${partnerId}`);
};

export function getEducationalLevelForAdmin() {
  return axios.get(`/admin/partners-list/educations`);
}
export function getCitiessForAdmin() {
  return axios.get(`/admin/partners-list/cities`);
}

export function getJobCategoriesForAdmin() {
  return axios.get(`/admin/partners-list/jobs`);
}

export function getCountriesForAdmin() {
  return axios.get(`/admin/partners-list/countries`);
}

export function getPartnersInPackage(
  packageId,
  currentPage,
  searchTerm,
  sortKey,
  sortDirection,
  startDate,
  endDate
) {
  return axios.get(`/admin/package-management/partners/${packageId}`, {
    params: {
      page: currentPage,
      search: searchTerm,
      sort_by: sortKey,
      sort_dir: sortDirection,
      date_from: startDate,
      date_to: endDate,
    },
  });
}
// add package
export function createNewPackage(packageData) {
  return axios.post(`/admin/package-management/create`, packageData);
}
// get data to update package
export function getPackageDataToEdit(packageId) {
  return axios.get(`/admin/package-management/details-for-update/${packageId}`);
}

// update package
export function updatePackageData(packageId, packageData) {
  return axios.patch(
    `/admin/package-management/update/${packageId}`,
    packageData
  );
}

// Get Dropdown data to add new package
export function getPackageCategories() {
  return axios.get(`/admin/package-management/categories`);
}
export function getPartnerTypes() {
  return axios.get(`/admin/package-management/partnerTypes`);
}
export function getPackageTypes() {
  return axios.get(`/admin/package-management/packageTypes`);
}
export function getCoursesForAddNewPackage() {
  return axios.get(`/admin/package-management/courses`);
}

export function getPackageDetails(packageId) {
  return axios.get(`/admin/package-management/details/${packageId}`);
}

// courses management

export function getListCourses(sortKey, sortDirection, currentPage) {
  return axios.get(`/admin/course-management/list-courses`, {
    params: {
      sort_by: sortKey,
      sort_dir: sortDirection,
      page: currentPage,
    },
  });
}

// Transactions
export function getListTransactionsHistory(
  TransCat,
  currentPage,
  searchTerm,
  sortKey,
  sortDirection,
  startDate,
  endDate,
  WalletType,
  endpoint = "adminTransactionHistory"
) {
  return axios.get(`/${endpoint}/list`, {
    params: {
      curPage: currentPage,
      perPage: 10,
      search: searchTerm,
      sortBy: sortKey,
      sortDir: sortDirection,
      fromDate: startDate,
      toDate: endDate,
      WalletType: WalletType,
      TransCat: TransCat,
    },
  });
}

export function getTransactionsCategory(endpoint = "adminTransactionHistory") {
  return axios.get(`/${endpoint}/dropdown/transactionCategories`);
}
export function getWalletTypes(endpoint = "adminTransactionHistory") {
  return axios.get(`/${endpoint}/dropdown/walletTypes`);
}
export function getTransactionDetails(
  transactionId,
  endpoint = "adminTransactionHistory"
) {
  return axios.get(`/${endpoint}/view/${transactionId}`);
}

// Courses crud for admin
export function getCourseDetails(courseId) {
  return axios.get(`/admin/course-management/details/${courseId}}`);
}

// Add New Social Media
export function addNewSocialMediaApi(courseId, data) {
  return axios.post(`/admin/course-management/create-social/${courseId}`, data);
}
// get social media dropdown
export function getSocialMediaDropdown() {
  return axios.get(`/admin/course-management/social-media-platforms`);
}
// get social media data to update
export function getSocialMediaDataToUpdate(courseId, socialMediaId) {
  return axios.get(
    `/admin/course-management/social-data-for-update/${courseId}/${socialMediaId}`
  );
}
// get social media dropdown
export function getCourseRatings(courseId, currentPage) {
  return axios.get(`/admin/course-management/ratings/${courseId}`, {
    params: {
      page: currentPage,
    },
  });
}
// Update Social Media
export function updateSocialMediaChannel(courseId, socialMediaId, data) {
  return axios.patch(
    `/admin/course-management/update-social/${courseId}/${socialMediaId}`,
    data
  );
}
// Delete Social Media
export function deleteSocialMediaChannel(courseId, socialMediaId) {
  return axios.delete(
    `/admin/course-management/delete-social/${courseId}/${socialMediaId}`
  );
}

// Lessons in course
export function getLessonsInCourse(courseId, currentPage) {
  return axios.get(`/admin/course-management/lessons/${courseId}`, {
    params: {
      page: currentPage,
    },
  });
}

// Add New Social Media
export function addNewCourseLessonApi(courseId, data) {
  return axios.post(
    `/admin/course-management/create-lesson/${courseId}}`,
    data
  );
}

// dropdown for add new lesson
export function getLessonTypes() {
  return axios.get(`/admin/course-management/lesson-types`);
}
export function getLessonsLevels() {
  return axios.get(`/admin/course-management/lesson-levels`);
}
export function getLessonDataToUpdate(courseId, lessonId) {
  return axios.get(
    `/admin/course-management/lesson-data-for-update/${courseId}/${lessonId}`
  );
}

// Update Lesson In Course
export function updateLessonInCourseApi(courseId, lessonId, data) {
  return axios.patch(
    `/admin/course-management/update-lesson/${courseId}/${lessonId}`,
    data
  );
}
// Update Course
export function updateCourseForAdmin(courseId, data) {
  return axios.post(`/admin/course-management/update-course/${courseId}`, data);
}

// Delete Lesson In Course
export function deleteLessonInCourseApi(courseId, lessonId) {
  return axios.delete(
    `/admin/course-management/delete-lesson/${courseId}/${lessonId}}`
  );
}
// get recorded lessons in course
export function getRecordedLessons(courseId, currentPage) {
  return axios.get(`/admin/course-management/recorded-lessons/${courseId}`, {
    params: {
      page: currentPage,
    },
  });
}
export function getCourseName(courseId) {
  return axios.get(`/admin/course-management/course-name/${courseId}`);
}

// Create New Course
export function createNewCourseForAdmin(data) {
  return axios.post(`/admin/course-management/create-course`, data);
}
// get course Data For Update
export function getCourseDataForUpdate(courseId) {
  return axios.get(
    `/admin/course-management/course-data-for-update/${courseId}`
  );
}
// create new course dropdown data for admin
export function getCourseTypes() {
  return axios.get(`/admin/course-management/course-types`);
}
export function getInstructorsDropdown() {
  return axios.get(`/admin/course-management/instructors`);
}
export function getPrerequisiteCourses() {
  return axios.get(`/admin/course-management/prerequisite-courses`);
}

// instructor module apis
export function getInstructorsListForAdmin(
  currentPage,
  sortKey,
  sortDirection
) {
  return axios.get(`/admin/instructor-management/list`, {
    params: {
      page: currentPage,
      sort_by: sortKey,
      sort_dir: sortDirection,
    },
  });
}

// instructor details
export function getInstructorDetails(instructorId) {
  return axios.get(`/admin/instructor-management/details/${instructorId}`);
}
// delete instructor
export function deleteInstructorData(instructorId) {
  return axios.delete(`/admin/instructor-management/delete/${instructorId}`);
}

// Add New Instructor
export function addNewInstructorApi(data) {
  return axios.post(`/admin/instructor-management/create`, data);
}
// Update Instructor Data
export function updateInstructorDataApi(instructorId, data) {
  return axios.post(
    `/admin/instructor-management/update/${instructorId}`,
    data
  );
}

//  get instructor data for update
export function getInstructorDataToUpdate(instructorId) {
  return axios.get(
    `/admin/instructor-management/get-data-for-update/${instructorId}`
  );
}
export function deactivateAccount(customToken) {
  return axios.post(
    `/client/account/delete-request`,
    {},
    {
      headers: {
        Authorization: `Bearer ${customToken}`,
      },
    }
  );
}
// get course lessons for clients
export function getCourseLessons(
  courseId,
  liveLessonsPerPage,
  liveLessonsCurPage,
  recordedLessonsPerPage,
  recordedLessonsCurPage
) {
  return axios.get(`/clientCourseLesson/details/${courseId}`, {
    params: {
      liveLessonsPerPage,
      liveLessonsCurPage,
      recordedLessonsPerPage,
      recordedLessonsCurPage,
    },
  });
}
// complete lesson
export function markLessonAsComplete(lessonId) {
  return axios.get(`/clientCourseLesson/markAsCompleted/${lessonId}`);
}
// partner profile
export function myProfileApi() {
  return axios.get(`/client/profile/view`);
}
//upload partner profile image
export function uploadProfileImageForPartner(data) {
  return axios.post(`/client/profile/upload`, data);
}
//get partner profile image
export function getPartnerProfileImage() {
  return axios.get(`/getProfilePic`);
}
// view Tabs Total Numbers ForAdmin
export function getTabsTotalNumbersForAdmin() {
  return axios.get(`/admin/partners-list/viewTabsTotalNumbers`);
}
// view Tabs Total Numbers ForPartne
export function getTabsTotalNumbersForPartner() {
  return axios.get(`/client/partners-list/viewTabsTotalNumbers`);
}
// get Partner Upliners
export function getPartnerUpliners(search, partnerId, currentPage) {
  return axios.get(`/admin/partners-list/clientUpliners/${partnerId}`, {
    params: {
      search: search,
      curPage: currentPage,
    },
  });
}
// get Partner clientDownliners
export function getPartnerDownliners(search, partnerId, currentPage) {
  return axios.get(`/admin/partners-list/clientDownliners/${partnerId}`, {
    params: {
      search: search,
      curPage: currentPage,
    },
  });
}
// Get Activation Reasons
export function getActivationReasons(isActive) {
  return axios.get(`/admin/partners-list/activationReasons?status=${isActive}`);
}
// Get Partner Current Status
export function getPartnerActivationStatus(id) {
  return axios.get(`/admin/partners-list/currentStatus/${id}`);
}

// Update Partner Activation Status
export function updatePartnerActivationStatus(id, data) {
  const params = new URLSearchParams();
  for (const key in data) {
    params.append(key, data[key]);
  }

  return axios.post(
    `/admin/partners-list/updateActivationStatus/${id}`,
    params,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
}

// Get Activation History For Each Partner
export function getPartnerActivationHistory(id, currentPage) {
  return axios.get(`/admin/partners-list/activationHistory/${id}`, {
    params: {
      curPage: currentPage,
    },
  });
}

// Delete Uncompleted Partner
export function deleteUncompletedPartner(id, data) {
  return axios.post(`/admin/deleteUncompletedClientAccount/${id}`, {
    deletionNotes: data,
  });
}

// Get Transactions History For Each Partner
export function getPartnerTransactionsHistory(
  partnerId,
  TransCat,
  currentPage,
  searchTerm,
  sortKey,
  sortDirection,
  startDate,
  endDate,
  WalletType
) {
  return axios.get(
    `/admin/partners-list/profile/transactionHistory/${partnerId}`,
    {
      params: {
        curPage: currentPage,
        perPage: 10,
        search: searchTerm,
        sortBy: sortKey,
        sortDir: sortDirection,
        fromDate: startDate,
        toDate: endDate,
        WalletType: WalletType,
        TransCat: TransCat,
      },
    }
  );
}

// Get Partner Settlement History
export function getPartnerSettlementHistory(id, currentPage) {
  return axios.get(`/admin/partners-list/profile/taswiaHistory/${id}`, {
    params: {
      curPage: currentPage,
    },
  });
}
// Get Course details-before-purchase
export function getCourseDetailsBeforePurchase(id) {
  return axios.get(`/client/course/details-before-purchase/${id}`);
}
// client renew Subscription
export function renewClientSubscription(data) {
  return axios.post("/client/renewSubscription/renew", data);
}
// client show notification for renew Subscription
export function showNotificationForRenew() {
  return axios.get(`/client/renewSubscription/my-notifications`);
}
// Get Subscription Durations
export function getSubscriptionDurationsDropdownList() {
  return axios.get(
    `/client/renewSubscription/list/availableSubscriptionDurations`
  );
}
// Get Renew Subscription List For Admin
export function getRenewSubscriptionList(endpoint, currentPage, searchTerm) {
  return axios.get(`/admin/renewSubscription/list/${endpoint}`, {
    params: {
      curPage: currentPage,
      search: searchTerm,
    },
  });
}
export function getExtensionPeriod(extendPeriod) {
  return axios.get(`/admin/renewSubscription/view/${extendPeriod}`);
}

export function deactivateClientsAccounts(data) {
  return axios.post(`/admin/renewSubscription/deactivateClientsAccounts`, data);
}

export function getAvailableSubscriptionDurationsForAdmin() {
  return axios.get(
    `/admin/renewSubscription/list/availableSubscriptionDurations`
  );
}
export function getDetailsAboutSelectedSubscriptionForAdmin(
  durationId,
  clientId
) {
  return axios.get(
    `/admin/renewSubscription/detailsAboutSelectedSubscription/${durationId}/${clientId}`
  );
}
export function clientPackageExpirationStatus(clientId) {
  return axios.get(
    `/admin/renewSubscription/clientPackageExpirationStatus/${clientId}`
  );
}

export function renewClientSubscriptionForAdmin(
  expirationStatus,
  clientId,
  data
) {
  return axios.post(`/admin/${expirationStatus}/${clientId}`, data);
}

export function getRenewSubscriptionsReports(
  search,
  fromDate,
  toDate,
  durationId,
  curPage
) {
  return axios.get(`/admin/reports/subscriptions/list`, {
    params: {
      search,
      fromDate,
      toDate,
      durationId,
      page: curPage,
    },
  });
}
export function getWalletsReport(search, walletTypes, page, filterToSend) {
  return axios.get(`/admin/reports/clients-wallet/list`, {
    params: {
      search,
      walletTypes,
      page,
      balanceOperator: filterToSend?.balanceOperator,
      balanceValue: filterToSend?.balanceValue,
      balanceFrom: filterToSend?.balanceFrom,
      balanceTo: filterToSend?.balanceTo,
    },
  });
}
export function getDeactivationHistoryReport(
  search,
  page,
  reasons,
  activeStatus,
  fromDate,
  toDate
) {
  return axios.get(`/admin/reports/deactivation-history/list`, {
    params: {
      search,
      page,
      reasons,
      activeStatus,
      fromDate,
      toDate,
    },
  });
}
export function getPvUplinerReport(
  search,
  page,
  pvStatus,
  pvPosition,
  fromDate,
  toDate
) {
  return axios.get(`/admin/reports/pv-upliner/list`, {
    params: {
      search,
      page,
      pvStatus,
      pvPosition,
      fromDate,
      toDate,
    },
  });
}
export function getPvDirectReport(search, page, pvStatus, fromDate, toDate) {
  return axios.get(`/admin/reports/pv-direct/list`, {
    params: {
      search,
      page,
      pvStatus,
      fromDate,
      toDate,
    },
  });
}

export function getExpiredSubscriptionReport(
  search,
  page,
  reactive,
  fromDate,
  toDate
) {
  return axios.get(`/admin/reports/expired-subscription/list`, {
    params: {
      search,
      page,
      reactive,
      fromDate,
      toDate,
    },
  });
}
export function getClientMessageList(page) {
  return axios.get(`/client/message/list`, {
    params: {
      page,
    },
  });
}
export function getClientMessageDetails(messageId) {
  return axios.get(`/client/message/details/${messageId}`);
}
export function sendReplyOnMessage(messageId, formData, endpointFor = "admin") {
  return axios.post(`/${endpointFor}/message/reply/${messageId}`, formData);
}
export function editReplyOnMessage(messageId, formData, endpointFor = "admin") {
  return axios.post(
    `/${endpointFor}/message/edit-reply/${messageId}`,
    formData
  );
}
export function deleteReplyOnMessage(replyId, endpointFor = "admin") {
  return axios.delete(`/${endpointFor}/message/delete-reply/${replyId}`);
}
export function sendNewMessage(formData) {
  return axios.post(`/client/message/create-message`, formData);
}

export function getMessagesListForAdmin(messageType, searchTerm, page) {
  const params = {
    search: searchTerm,
    page,
  };
  // to get unseen messages and ignore the message type
  messageType === "unseen"
    ? (params.unseen = 1)
    : (params.messageType = messageType);

  return axios.get(`/admin/message/list`, {
    params,
  });
}
export function getMessageDetailsForAdmin(messageId) {
  return axios.get(`/admin/message/details/${messageId}`);
}
export function getPartnersToSendMessages(page, searchTerm) {
  return axios.get(`/admin/message/partners`, {
    params: {
      page,
      search: searchTerm,
    },
  });
}
export function sendNewMessageFromAdminToPartner(formData, partnerId) {
  return axios.post(`/admin/message/create-message/${partnerId}`, formData);
}

export function getPartnerNameAndImage(partnerID) {
  return axios.get(`/admin/message/client-name-and-image/${partnerID}`);
}
export function getRepliesForAdmin(messageId, page) {
  return axios.get(`/admin/message/replies/${messageId}`, {
    params: {
      page,
    },
  });
}
export function getRepliesForPartner(messageId, page) {
  return axios.get(`/client/message/replies/${messageId}`, {
    params: {
      page,
    },
  });
}
// get Payment Channels
export function getPaymentChannels() {
  return axios.get(`/new/client/payment-channels`);
}
// get Vouchers List
export function getVouchersList(currentPage) {
  return axios.get(`/client/voucher/list`, {
    params: {
      page: currentPage,
    },
  });
}
// voucher redeem
export function clientVoucherRedeem(voucherId) {
  return axios.post(`/client/voucher/redeem/${voucherId}`);
}
// my voucher
export function getMyVouchers(currentPage) {
  return axios.get(`/client/voucher/my-vouchers`, {
    params: {
      page: currentPage,
    },
  });
}

// only using for online payment
export function purchasePackageStep4(createdClientId, packageId, voucherCode) {
  return axios.post(`/new/client/step4/${createdClientId}/${packageId}`, {
    params: {
      voucherCode,
    },
  });
}
